import {
  GET_DATAGUARD_HEADER_DATA,
  SET_DATAGUARD_HEADER_DATA,
  SET_DATAGUARD_HEATMAP_DATA,
  GET_DATAGUARD_HEATMAP_DATA,
  GET_DATAGUARD_ROLES_DATA,
  SET_DATAGUARD_ROLES_DATA,
  GET_USER_ROLE_URL,
  GET_BEHAVIOR_MODEL_URL,
  SET_DATAGUARD_BEHAVIOR_DATA,
  GET_DATAGUARD_BEHAVIOR_DATA,
  LOCATION_SUMMARY_API,
  GET_LOCATION_SUMMARY,
  SET_LOCATION_SUMMARY,
  GET_KEY_DOC_OWNER_DATA,
  SET_KEY_DOC_OWNER_DATA,
  KEY_DOC_OWNER_API,
  notificationToggle,
  DATA_GUARD_NOTIFICATION_TOGGLE,
  SET_NOTIFICATION_UPDATE_STATUS,
  revokePublicAccessAPI,
  PUBLIC_ACCESS_REVOKE_USER,
  SET_REVOKE_ACCESS_UPDATE_STATUS,
} from "../Utility/DataguardConstant";
import {
  getCubejsApi,
} from "../../../components/common/Dashboard/cubejs-util";
import { getAxiosHeaders, getService } from "../../../library/RestAPI";

const { takeEvery, put, select, call } = require("redux-saga/effects");

function* fetchRolesData(action) {
  try {
    yield put({ type: 'SET_ROLES_LOADER', payload: true });
    const { fromTimeStamp, toTimeStamp } = action.payload;
    let options = {
      method: "GET",
      url: `${GET_USER_ROLE_URL}?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}`,
      headers: getAxiosHeaders(true),
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({ type: SET_DATAGUARD_ROLES_DATA, payload: response.data });
    }
    yield put({ type: 'SET_ROLES_LOADER', payload: false });
  } catch (error) {
    yield put({ type: 'SET_ROLES_LOADER', payload: false });
    console.error("Error fetching roles data:", error);
    // Handle error appropriately
  }
}

function* fetchBehaviorData(action) {
  try {
    yield put({ type: 'SET_BEHAVIOR_LOADER', payload: true });
    const { fromTimeStamp, toTimeStamp } = action.payload;
    let options = {
      method: "GET",
      url: `${GET_BEHAVIOR_MODEL_URL}?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}`,
      headers: getAxiosHeaders(true),
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({ type: SET_DATAGUARD_BEHAVIOR_DATA, payload: response.data });
    }
    yield put({ type: 'SET_BEHAVIOR_LOADER', payload: false });
  } catch (error) {
    yield put({ type: 'SET_BEHAVIOR_LOADER', payload: false });
    console.error("Error fetching behavior data:", error);
    // Handle error appropriately
  }
}

function* fetchHeaderData(action) {
  const { fromTimeStamp, toTimeStamp } = action.payload;
  const cubejs = getCubejsApi();
  const suspiciousHeaderData = {
    measures: [
      "DataguardSuspiciousUsers.totalUsers",
      "DataguardSuspiciousUsers.suspiciousUser",
    ],
    filters: [
      {
        or: [
          {
            member: "DataguardSuspiciousUsers.eventTime",
            operator: "notSet"
          },
          {
            and: [
              {
                member: "DataguardSuspiciousUsers.eventTime",
                operator: "gte",
                values: [`${fromTimeStamp}`]
              },
              {
                member: "DataguardSuspiciousUsers.eventTime",
                operator: "lte",
                values: [`${toTimeStamp}`]
              }
            ]
          }
        ]
      }
    ],
  };

  const publicAccessData = {
    measures: [
      "DataguardPublicAccess.totalCount",
      "DataguardPublicAccess.publicCount",
    ],
  };

  try {
    yield put({ type: 'SET_HEADER_LOADER', payload: true });
    const suspiciousData = yield cubejs.load(suspiciousHeaderData);
    const publicData = yield cubejs.load(publicAccessData);

    const suspicious = suspiciousData.rawData();
    const publicAccessRaw = publicData.rawData();

    const dataguardData = {
      suspicious: {
        totalCount: parseInt(
          suspicious[0]["DataguardSuspiciousUsers.totalUsers"]
        ),
        alertCount: parseInt(
          suspicious[0]["DataguardSuspiciousUsers.suspiciousUser"]
        ),
      },
      publicAccess: {
        totalCount: parseInt(
          publicAccessRaw[0]["DataguardPublicAccess.totalCount"]
        ),
        alertCount: parseInt(
          publicAccessRaw[0]["DataguardPublicAccess.publicCount"]
        ),
      },
    };

    yield put({ type: SET_DATAGUARD_HEADER_DATA, payload: dataguardData });
    yield put({ type: 'SET_HEADER_LOADER', payload: false });
  } catch (err) {
    yield put({ type: 'SET_HEADER_LOADER', payload: false });
    console.log(err);
  }
}

function* fetchHeatmapData(action) {
  const cubejs = getCubejsApi();

  const heatmapQuery = {
    dimensions: [
      "DataguardPublicHeatmap.username",
      "DataguardPublicHeatmap.totalPublicResources"
    ],
    order: {
      "DataguardPublicHeatmap.totalPublicResources": "desc"
    },
    limit: action.payload?.limit || 50,
  };
  const totalAssetsQuery = {
    "measures": ["DataguardTotalAssets.totalAssets"]
  };

  try {
    yield put({ type: 'SET_HEATMAP_LOADER', payload: true });
    const result = yield cubejs.load(heatmapQuery);
    const resultTotal = yield cubejs.load(totalAssetsQuery);
    const rawData = result.rawData();
    const totalAssets = resultTotal.rawData();

    // Transform data for heatmap format
    const heatmapData = rawData.map(item => ({
      count: parseInt(item["DataguardPublicHeatmap.totalPublicResources"]),
      username: item["DataguardPublicHeatmap.username"]
    }));
    const totalAssetsCount = totalAssets[0]["DataguardTotalAssets.totalAssets"] || 0;

    yield put({ type: SET_DATAGUARD_HEATMAP_DATA, payload: { heatmapData, totalAssetsCount } });
    yield put({ type: 'SET_HEATMAP_LOADER', payload: false });
  } catch (err) {
    yield put({ type: 'SET_HEATMAP_LOADER', payload: false });
    console.error("Error fetching heatmap data:", err);
  }
}

function* fetchLocationSummary(action) {
  try {
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: true });
    const { fromTimeStamp, toTimeStamp } = action.payload;
    let options = {
      method: "GET",
      url: `${LOCATION_SUMMARY_API}?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}`,
      headers: getAxiosHeaders(true),
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({ type: SET_LOCATION_SUMMARY, payload: response.data });
    }
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
  } catch (error) {
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
    console.error("Error fetching location summary data:", error);
    // Handle error appropriately
  }
}

function* fetchKeyDocOwnerData(action) {
  try {
    yield put({ type: 'SET_KEY_DOC_OWNER_LOADER', payload: true });
    const { fromTimeStamp, toTimeStamp } = action.payload;
    let options = {
      method: "GET",
      url: `${KEY_DOC_OWNER_API}?fromTimeStamp=${fromTimeStamp}&toTimeStamp=${toTimeStamp}`,
      headers: getAxiosHeaders(true),
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({ type: SET_KEY_DOC_OWNER_DATA, payload: response.data });
    }
    yield put({ type: 'SET_KEY_DOC_OWNER_LOADER', payload: false });
  } catch (error) {
    yield put({ type: 'SET_KEY_DOC_OWNER_LOADER', payload: false });
    console.error("Error fetching key document owner data:", error);
    // Handle error appropriately
  }
}

function* dataGuardNotificationToggle(action) {
  yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: true });
  const { state, data } = action.payload;
  try {
    let options = {
      method: "PUT",
      url: notificationToggle(state),
      headers: {
        ...getAxiosHeaders(true),
        "Content-Type": "text/plain",
      },
      data: data,
    };
    const response = yield getService(options);
    if (response && response.status === 200) {
      yield put({ type: SET_NOTIFICATION_UPDATE_STATUS, payload: true });
      yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
    }
    else {
      yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
    }
  } catch (error) {
    console.error("Error toggling notification:", error);
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });

  }
}

function* revokePublicAccessUser(action) {
  try {
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: true });
    const { dataSourceId, userEmailId } = action.payload;

    if (Array.isArray(dataSourceId) && dataSourceId.length > 0) {
      for (const id of dataSourceId) {
        const options = {
          method: "PUT",
          url: revokePublicAccessAPI(id, userEmailId),
          headers: getAxiosHeaders(true),
        };
        const response = yield getService(options);

        if (response?.status === 204) {
          console.log(`Revoked access for DS: ${id}`);
          yield put({ type: SET_REVOKE_ACCESS_UPDATE_STATUS, payload: true });
        }
        yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
      }
      console.log("All revokes completed");
    } else {
      console.log("No dataSourceIds to revoke");
      yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
    }
  } catch (error) {
    console.error("Error revoking public access:", error);
    yield put({ type: 'SET_LOCATION_SUMMARY_LOADER', payload: false });
  }
}

function* DataGuardSaga() {
  yield takeEvery(GET_DATAGUARD_HEADER_DATA, fetchHeaderData);
  yield takeEvery(GET_DATAGUARD_HEATMAP_DATA, fetchHeatmapData);
  yield takeEvery(GET_DATAGUARD_ROLES_DATA, fetchRolesData);
  yield takeEvery(GET_DATAGUARD_BEHAVIOR_DATA, fetchBehaviorData);
  yield takeEvery(GET_LOCATION_SUMMARY, fetchLocationSummary);
  yield takeEvery(GET_KEY_DOC_OWNER_DATA, fetchKeyDocOwnerData);
  yield takeEvery(DATA_GUARD_NOTIFICATION_TOGGLE, dataGuardNotificationToggle);
  yield takeEvery(PUBLIC_ACCESS_REVOKE_USER, revokePublicAccessUser);
}

export default DataGuardSaga;
